import React from 'react'
import DashboardLayout from 'layout/DashboardLayout'
import { Link } from 'react-router-dom'
import Icon from 'components/UI/Icons'

const Application = () => {
    return (
        <DashboardLayout alt='true'>
            <div className='w-11/12 xl:w-10/12 mx-auto mt-5 mb-12 md:mt-12'>
                <Link to='/' className='flex items-center'>
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                            opacity='0.1'
                            d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                            fill='#222222'
                        />
                        <path
                            d='M14.6774 7.46323C15.0121 7.1285 15.0121 6.58579 14.6774 6.25105C14.3426 5.91632 13.7999 5.91632 13.4652 6.25105L8.32234 11.3939C7.99785 11.7184 7.98649 12.2409 8.29659 12.5792L13.0109 17.722C13.3308 18.071 13.873 18.0946 14.2219 17.7747C14.5709 17.4548 14.5944 16.9126 14.2746 16.5637L10.1148 12.0258L14.6774 7.46323Z'
                            fill='#222222'
                        />
                    </svg>
                    <span className='ml-2 font-medium text-sm text-dark tracking-neg-wide'>Go back to Dashboard</span>
                </Link>
                <div className='grid gap-6 xl:gap-10 grid-cols-9 mt-6'>
                    <div className='col-span-9 lg:col-span-6'>
                        <div className='bg-white border border-snow-100 rounded-lg py-6 h-full'>
                            <div className='flex items-center px-10 '>
                                <svg
                                    width='50'
                                    height='50'
                                    viewBox='0 0 50 50'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M10.4167 4.1665H39.5833C41.8845 4.1665 43.75 6.03198 43.75 8.33317V12.4998C43.75 14.801 41.8845 16.6665 39.5833 16.6665H10.4167C8.11548 16.6665 6.25 14.801 6.25 12.4998V8.33317C6.25 6.03198 8.11548 4.1665 10.4167 4.1665ZM22.9167 8.33317C21.7661 8.33317 20.8333 9.26591 20.8333 10.4165C20.8333 11.5671 21.7661 12.4998 22.9167 12.4998H33.3333C34.4839 12.4998 35.4167 11.5671 35.4167 10.4165C35.4167 9.26591 34.4839 8.33317 33.3333 8.33317H22.9167ZM14.5833 12.4998C15.7339 12.4998 16.6667 11.5671 16.6667 10.4165C16.6667 9.26591 15.7339 8.33317 14.5833 8.33317C13.4327 8.33317 12.5 9.26591 12.5 10.4165C12.5 11.5671 13.4327 12.4998 14.5833 12.4998Z'
                                        fill='#52BD95'
                                    />
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M10.4167 18.75H39.5833C41.8845 18.75 43.75 20.6155 43.75 22.9167V27.0833C43.75 29.3845 41.8845 31.25 39.5833 31.25H10.4167C8.11548 31.25 6.25 29.3845 6.25 27.0833V22.9167C6.25 20.6155 8.11548 18.75 10.4167 18.75ZM22.9167 22.9167C21.7661 22.9167 20.8333 23.8494 20.8333 25C20.8333 26.1506 21.7661 27.0833 22.9167 27.0833H33.3333C34.4839 27.0833 35.4167 26.1506 35.4167 25C35.4167 23.8494 34.4839 22.9167 33.3333 22.9167H22.9167ZM14.5833 27.0833C15.7339 27.0833 16.6667 26.1506 16.6667 25C16.6667 23.8494 15.7339 22.9167 14.5833 22.9167C13.4327 22.9167 12.5 23.8494 12.5 25C12.5 26.1506 13.4327 27.0833 14.5833 27.0833Z'
                                        fill='#0D1537'
                                    />
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M10.4167 33.3335H39.5833C41.8845 33.3335 43.75 35.199 43.75 37.5002V41.6668C43.75 43.968 41.8845 45.8335 39.5833 45.8335H10.4167C8.11548 45.8335 6.25 43.968 6.25 41.6668V37.5002C6.25 35.199 8.11548 33.3335 10.4167 33.3335ZM22.9167 37.5002C21.7661 37.5002 20.8333 38.4329 20.8333 39.5835C20.8333 40.7341 21.7661 41.6668 22.9167 41.6668H33.3333C34.4839 41.6668 35.4167 40.7341 35.4167 39.5835C35.4167 38.4329 34.4839 37.5002 33.3333 37.5002H22.9167ZM14.5833 41.6668C15.7339 41.6668 16.6667 40.7341 16.6667 39.5835C16.6667 38.4329 15.7339 37.5002 14.5833 37.5002C13.4327 37.5002 12.5 38.4329 12.5 39.5835C12.5 40.7341 13.4327 41.6668 14.5833 41.6668Z'
                                        fill='#0D1537'
                                    />
                                </svg>
                                <div className='ml-2'>
                                    <p className='text-dark text-lg font-medium tracking-wide'>App name here</p>
                                    <p className='text-dark opacity-50 text-sm mt-1'>Date and time: Oct 11 - 10:30pm</p>
                                </div>
                            </div>

                            <div className='mt-6 mb-8'>
                                <hr className='border-t-2 border-snow-100' />
                            </div>

                            <div className='px-10 grid grid-cols-5 items-center xl:gap-0 gap-10  mb-10'>
                                <div className='col-span-5 xl:col-span-4'>
                                    <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>
                                        <div className='col-span-1'>
                                            <p className='text-dark text-sm opacity-50 tracking-wide'>
                                                Total customers
                                            </p>
                                            <p className='text-dark font-medium tracking-wide mt-2'>5,000</p>
                                        </div>
                                        <div className='col-span-1'>
                                            <p className='text-dark text-sm opacity-50 tracking-wide'>App url</p>
                                            <p className='text-dark font-medium tracking-wide mt-2'>
                                                http://localhost:port{' '}
                                            </p>
                                        </div>
                                        <div className='col-span-1'>
                                            <p className='text-dark text-sm opacity-50 tracking-wide'>Health status</p>
                                            <p className='text-green font-medium tracking-wide mt-2'>Active </p>
                                        </div>
                                        <div className='col-span-1'>
                                            <p className='text-dark text-sm opacity-50 tracking-wide'>
                                                API Key <span style={{ fontSize: '10px' }}>(Tap to copy)</span>
                                            </p>
                                            <p className='text-dark font-medium tracking-wide mt-2'>
                                                *********************
                                            </p>
                                        </div>
                                        <div className='col-span-1'>
                                            <p className='text-dark text-sm opacity-50 tracking-wide'>Token</p>
                                            <p className='text-dark font-medium tracking-wide mt-2'>L3@RNJWT</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-span-5 xl:col-span-1'>
                                    <button className='border border-smoke-200 rounded-xs text-dark text-sm py-3 px-6'>
                                        Report Issue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-span-9 md:col-span-5 lg:col-span-3'>
                        <div className='bg-smoke-100 rounded-lg w-full px-8 relative pb-8 overflow-hidden h-full'>
                            <div className='h-24 w-full'></div>
                            <div>
                                <svg
                                    width='38'
                                    height='31'
                                    viewBox='0 0 38 31'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        opacity='0.3'
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M3.75 0.666626H33.75C35.8211 0.666626 37.5 2.34556 37.5 4.41663V26.9166C37.5 28.9877 35.8211 30.6666 33.75 30.6666H3.75C1.67893 30.6666 0 28.9877 0 26.9166V4.41663C0 2.34556 1.67893 0.666626 3.75 0.666626Z'
                                        fill='#52BD95'
                                    />
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M30.9375 13.7919H6.5625C5.0092 13.7919 3.75 15.0511 3.75 16.6044V17.5419H12.3484C12.8456 17.5419 13.3225 17.7394 13.6742 18.091L15.5492 19.966C16.3981 20.815 17.5495 21.2919 18.75 21.2919C19.9505 21.2919 21.1019 20.815 21.9508 19.966L23.8258 18.091C24.1775 17.7394 24.6544 17.5419 25.1516 17.5419H33.75V16.6044C33.75 15.0511 32.4908 13.7919 30.9375 13.7919Z'
                                        fill='#52BD95'
                                    />
                                    <path
                                        fillRule='evenodd'
                                        clipRule='evenodd'
                                        d='M6.5625 4.41663C5.0092 4.41663 3.75 5.67583 3.75 7.22913V8.16663H33.75V7.22913C33.75 5.67583 32.4908 4.41663 30.9375 4.41663H6.5625Z'
                                        fill='#52BD95'
                                    />
                                </svg>

                                <p className='text-dark font-medium text-xl pt-3 tracking-xs'>Production Collections</p>
                                <p className='text-dark opacity-50 text-base pt-2 w-10/12'>
                                    Here you can test how our systems works, Click the button to experience it.
                                </p>
                                <div className='mt-6'>
                                    <button className='bg-white border border-smoke-200 px-5 py-3 rounded-xs text-sm relative z-50 flex items-center'>
                                        <Icon name='download' className='w-6' />
                                        <span className='ml-2'>Download</span>
                                    </button>
                                </div>
                            </div>
                            <div className='absolute bottom-0 right-0 w-11/12 -mr-10'>
                                <img src={require('assets/img/pole.png')} alt='pole' className='w-4/12 ml-auto' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default Application
